import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarAdminComponent } from './navbar-admin.component';
import { SharedModule } from '../../shared.module';

@NgModule({
    imports: [ RouterModule, CommonModule, SharedModule ],
    declarations: [ NavbarAdminComponent  ],
    exports: [ NavbarAdminComponent],
})

export class NavbarAdminModule {}
